import React, { useContext, Suspense, lazy } from "react";
import { AppContext } from "../../contexts/AppContext/AppContext";
import EnglishRoute from "../../components/EnglishRoutes/EnglishRoutes";

function MainLayout(props) {
  return <EnglishRoute></EnglishRoute>;
}
export default MainLayout;
